import React, { useEffect, useState } from "react";
import FsLightbox from "fslightbox-react";

// 👇 Semua gambar dipastikan menggunakan .webp 👇
import hiasan2 from "../../Img/hiasan-2.webp";
import pot1 from "../../Img/pot1.webp";
import pot2 from "../../Img/pot2.webp";
import pot3 from "../../Img/pot3.webp";
import pot4 from "../../Img/pot4.webp";
import pot5 from "../../Img/pot5.webp";
import pot6 from "../../Img/pot6.webp";
import pot7 from "../../Img/pot7.webp";
import pot8 from "../../Img/pot8.webp";
import lan1 from "../../Img/lan1.webp";
import lan5 from "../../Img/lan5.webp";
import lan3 from "../../Img/lan3.webp";
import lan4 from "../../Img/lan4.webp";

import AOS from "aos";
import "aos/dist/aos.css";

export default function Gallery() {
  const [toggler, setToggler] = useState(false);
  const [gallerySlide, setGallerySlide] = useState(1);

  // Array semua foto untuk FsLightbox sesuai urutan kemunculan di Grid
  const allImages = [
    lan1,
    pot1,
    pot2,
    pot3,
    pot4,
    lan5,
    lan3,
    pot5,
    pot6,
    pot7,
    pot8,
    lan4,
  ];

  const bukaGallery = (index) => {
    setGallerySlide(index + 1); // FsLightbox index dimulai dari 1
    setToggler(!toggler);
  };

  useEffect(() => {
    AOS.init({
      once: true,
      duration: 1000,
    });
  }, []);

  return (
    <>
      <FsLightbox toggler={toggler} sources={allImages} slide={gallerySlide} />

      <style>
        {`
          .dust-particles {
            position: absolute;
            top: 0;
            left: 0;
            width: 2px;
            height: 2px;
            background: transparent;
            box-shadow: 
              20vw 10vh 1px 0.5px rgba(255,255,255,0.15),
              40vw 30vh 1px 0.5px rgba(255,255,255,0.2),
              60vw 15vh 1px 0.5px rgba(255,255,255,0.1),
              80vw 45vh 1px 0.5px rgba(255,255,255,0.2),
              15vw 60vh 1px 0.5px rgba(255,255,255,0.15),
              50vw 80vh 1px 0.5px rgba(255,255,255,0.25),
              75vw 65vh 1px 0.5px rgba(255,255,255,0.1),
              90vw 85vh 1px 0.5px rgba(255,255,255,0.2),
              10vw 90vh 1px 0.5px rgba(255,255,255,0.15),
              30vw 95vh 1px 0.5px rgba(255,255,255,0.1);
            animation: move-dust 40s linear infinite;
            will-change: transform;
          }

          .dust-particles::after {
            content: " ";
            position: absolute;
            top: 100vh;
            width: 3px;
            height: 3px;
            background: transparent;
            box-shadow: 
              25vw 20vh 1px 0.5px rgba(255,255,255,0.1),
              45vw 40vh 1px 0.5px rgba(255,255,255,0.2),
              65vw 25vh 1px 0.5px rgba(255,255,255,0.15),
              85vw 55vh 1px 0.5px rgba(255,255,255,0.1),
              20vw 70vh 1px 0.5px rgba(255,255,255,0.2),
              55vw 90vh 1px 0.5px rgba(255,255,255,0.15),
              80vw 75vh 1px 0.5px rgba(255,255,255,0.2),
              95vw 15vh 1px 0.5px rgba(255,255,255,0.1);
            animation: move-dust-slow 60s linear infinite;
            will-change: transform;
          }

          @keyframes move-dust {
            from { transform: translateY(0); }
            to { transform: translateY(-150vh); } 
          }

          @keyframes move-dust-slow {
            from { transform: translateY(0); }
            to { transform: translateY(-200vh); } 
          }
        `}
      </style>

      {/* 👇 PERBAIKAN: id="gallery" dipindah ke sini agar judul tidak terpotong saat navigasi 👇 */}
      <div
        id="gallery"
        className="relative py-24 bg-gradient-to-b from-[#4A0E17] via-[#5C1420] to-[#360810] overflow-hidden"
      >
        <div className="absolute inset-0 pointer-events-none">
          <div className="dust-particles"></div>
          <div className="dust-particles" style={{ top: "100vh" }}></div>
        </div>

        {/* Overlay Texture Tipis */}
        <div
          className="absolute inset-0 opacity-[0.03] mix-blend-overlay pointer-events-none"
          style={{
            backgroundImage:
              "radial-gradient(circle at center, #ffffff 1px, transparent 1px)",
            backgroundSize: "20px 20px",
          }}
        ></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          {/* Header Galeri */}
          <div className="flex flex-col items-center mb-16">
            <img
              data-aos="fade-down"
              src={hiasan2}
              alt="hiasan2"
              className="w-[70px] mb-6"
            />
            <h1
              data-aos="zoom-in"
              data-aos-delay="200"
              className="text-center text-[#F5E6D3] custom-font-2 text-5xl md:text-6xl tracking-wide mb-2 drop-shadow-lg"
            >
              Our Moments
            </h1>
            <p
              data-aos="fade-up"
              data-aos-delay="300"
              className="text-[#D8A6A6] font-light tracking-[0.2em] uppercase text-sm"
            >
              A Glimpse of Happiness
            </p>
          </div>

          {/* MASONRY GRID LAYOUT MODERN */}
          {/* PERBAIKAN: id="gallery" sudah dihapus dari div grid ini */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
            {/* BARIS 1 */}
            <div
              className="col-span-2 md:col-span-4 rounded-xl overflow-hidden shadow-2xl group cursor-pointer"
              onClick={() => bukaGallery(0)}
              data-aos="fade-up"
            >
              <img
                src={lan1}
                loading="lazy"
                alt="Landscape 1"
                className="w-full h-[250px] md:h-[450px] object-cover transition-transform duration-700 group-hover:scale-110 group-hover:brightness-110 will-change-transform"
              />
            </div>

            {/* BARIS 2 */}
            <div
              className="col-span-1 md:col-span-2 rounded-xl overflow-hidden shadow-xl group cursor-pointer"
              onClick={() => bukaGallery(1)}
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <img
                src={pot1}
                loading="lazy"
                alt="Portrait 1"
                className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover transition-transform duration-700 group-hover:scale-110 group-hover:brightness-110 will-change-transform"
              />
            </div>
            <div
              className="col-span-1 md:col-span-2 rounded-xl overflow-hidden shadow-xl group cursor-pointer"
              onClick={() => bukaGallery(2)}
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <img
                src={pot2}
                loading="lazy"
                alt="Portrait 2"
                className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover transition-transform duration-700 group-hover:scale-110 group-hover:brightness-110 will-change-transform"
              />
            </div>

            {/* BARIS 3 */}
            <div
              className="col-span-1 md:col-span-2 rounded-xl overflow-hidden shadow-xl group cursor-pointer"
              onClick={() => bukaGallery(3)}
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <img
                src={pot3}
                loading="lazy"
                alt="Portrait 3"
                className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover transition-transform duration-700 group-hover:scale-110 group-hover:brightness-110 will-change-transform"
              />
            </div>
            <div
              className="col-span-1 md:col-span-2 rounded-xl overflow-hidden shadow-xl group cursor-pointer"
              onClick={() => bukaGallery(4)}
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <img
                src={pot4}
                loading="lazy"
                alt="Portrait 4"
                className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover transition-transform duration-700 group-hover:scale-110 group-hover:brightness-110 will-change-transform"
              />
            </div>

            {/* BARIS 4 */}
            <div
              className="col-span-2 md:col-span-4 rounded-xl overflow-hidden shadow-2xl group cursor-pointer"
              onClick={() => bukaGallery(5)}
              data-aos="fade-up"
            >
              <img
                src={lan5}
                loading="lazy"
                alt="Landscape 2"
                className="w-full h-[250px] md:h-[450px] object-cover transition-transform duration-700 group-hover:scale-110 group-hover:brightness-110 will-change-transform"
              />
            </div>

            {/* BARIS 5 */}
            <div
              className="col-span-2 md:col-span-4 rounded-xl overflow-hidden shadow-2xl group cursor-pointer"
              onClick={() => bukaGallery(6)}
              data-aos="fade-up"
            >
              <img
                src={lan3}
                loading="lazy"
                alt="Landscape 3"
                className="w-full h-[250px] md:h-[450px] object-cover transition-transform duration-700 group-hover:scale-110 group-hover:brightness-110 will-change-transform"
              />
            </div>

            {/* BARIS 6 */}
            <div
              className="col-span-1 md:col-span-2 rounded-xl overflow-hidden shadow-xl group cursor-pointer"
              onClick={() => bukaGallery(7)}
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <img
                src={pot5}
                loading="lazy"
                alt="Portrait 5"
                className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover transition-transform duration-700 group-hover:scale-110 group-hover:brightness-110 will-change-transform"
              />
            </div>
            <div
              className="col-span-1 md:col-span-2 rounded-xl overflow-hidden shadow-xl group cursor-pointer"
              onClick={() => bukaGallery(8)}
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <img
                src={pot6}
                loading="lazy"
                alt="Portrait 6"
                className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover transition-transform duration-700 group-hover:scale-110 group-hover:brightness-110 will-change-transform"
              />
            </div>

            {/* BARIS 7 */}
            <div
              className="col-span-1 md:col-span-2 rounded-xl overflow-hidden shadow-xl group cursor-pointer"
              onClick={() => bukaGallery(9)}
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <img
                src={pot7}
                loading="lazy"
                alt="Portrait 7"
                className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover transition-transform duration-700 group-hover:scale-110 group-hover:brightness-110 will-change-transform"
              />
            </div>
            <div
              className="col-span-1 md:col-span-2 rounded-xl overflow-hidden shadow-xl group cursor-pointer"
              onClick={() => bukaGallery(10)}
              data-aos="fade-up"
              data-aos-delay="200"
            >
              <img
                src={pot8}
                loading="lazy"
                alt="Portrait 8"
                className="w-full h-[200px] sm:h-[300px] md:h-[400px] object-cover transition-transform duration-700 group-hover:scale-110 group-hover:brightness-110 will-change-transform"
              />
            </div>

            {/* BARIS 8 (Penutup) */}
            <div
              className="col-span-2 md:col-span-4 rounded-xl overflow-hidden shadow-2xl group cursor-pointer"
              onClick={() => bukaGallery(11)}
              data-aos="fade-up"
              data-aos-offset="50"
            >
              <img
                src={lan4}
                loading="lazy"
                alt="Landscape 4"
                className="w-full h-[250px] md:h-[450px] object-cover transition-transform duration-700 group-hover:scale-110 group-hover:brightness-110 will-change-transform"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
